import { useEffect } from "react";
import styles from "./toast.module.scss";

interface ToastProps {
    message: string;
    onDismiss: () => void;
    durationMs?: number;
}

// Render with a fresh `key` for each new toast (even repeats of the same
// message) so the auto-dismiss timer and entrance animation restart.
function Toast({ message, onDismiss, durationMs = 2500 }: ToastProps) {
    useEffect(() => {
        const timer = setTimeout(onDismiss, durationMs);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styles.toast} role="status" aria-live="polite">
            {message}
        </div>
    );
}

export default Toast;
